import React from 'react';
import VaccinationDetails from './Components/VaccinationDetails';

const VaccinationDetailsPage = () => {
  return (
    <div className="w-full h-full">
      <div className="pb-1">
        <VaccinationDetails />
      </div>
    </div>
  );
};

export default VaccinationDetailsPage;
